import React from 'react'
import styles from './Video.module.css'

const Video = () => {
    return (
        <div className={styles.container}>
            <video src="https://sazuli.pt/uploads/Sazuli Home.mp4" autoPlay loop muted></video>
            <h1 className={styles.textOverlay}>
                Do chão ao charme
            </h1>
        </div>
    )
}

export default Video
